import axios from 'axios';
import { customAxios } from '../../common/customAxios';

interface patchCropFavoriteParams {
  reqBody: {
    largeCategoryCode: string;
    middleCategoryCode: string;
    smallCategoryCode: string;
    wholesaleMarketCodes: string[];
  };
}

export const patchCropFavorite = ({ reqBody }: patchCropFavoriteParams) => {
  // return axios.patch('http://localhost:3002/mock/crops/favorite', reqBody);
  return customAxios.patch('/crops/favorites', reqBody);
};
